/* When the document section is modified which will inturn modify the company details call,
   pan name value gets lost since BE does not store the pan name value and  hence to retain the pan name value
   when moving from one step to another created this context. */

import { createContext } from 'react';
var panNameSection = {
  panFullNameFieldValue: ''
};
var defaultState = {
  panNameValue: panNameSection,
  setPanNameFromInput: function setPanNameFromInput(panNameValue) {
    return panNameValue;
  }
};
var PanFullNameContext = /*#__PURE__*/createContext(defaultState);
export { PanFullNameContext, panNameSection };